"use strict";

// General modules
var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Promise = require('promise-polyfill');
var ajax = require('ajax');

var SafeStorage = require('storage/SafeStorage');
var MiniTimer = require('MiniTimer');
var TemplateCache = require('TemplateCache');

// App modules
var SidebarView = require('./views/SidebarView');
var ResultView = require('./views/ResultView');
var SortOrderView = require('./views/SortOrderView');

var TraminoClientsMap = require('../TraminoClientsMap');


var Result = Backbone.Model.extend({});


var ResultStore = Backbone.Collection.extend({
    model: Result,

    getVisible: function() {
        return this.filter(function(result) {
            return result.visible;
        });
    },

});


var BrowserApp = Backbone.Model.extend({

    defaults: function() {
        return {
            /* Parameters */
            group: null, /* Partnergruppe (client_group) */
            tagGroupFilter: [], /* Auf bestimmte Tag-Gruppen filtern */

            /* State */
            selectedTags: [],
            searchQuery: "", /* Aktuelle Suchanfrage */
            sortBy: 'auto', /* auto, stars, ratings, price */
            tagsCount: {}, /* Mapping of tag_id => Count */
            tab: "list", /* list, map */
            isTouchDevice: false, /* Sind wir auf Mobile? */
            favoritesOnly: false, /* Nur Favoriten anzeigen? */
        };
    },

    //
    // Lifecycle Methods
    //

    /**
     * Grundsätzlichen Zustand der Anwendung intialisieren.
     */
    initialize: function() {
        if ( typeof window.Raven !== "undefined" ) {
            Raven.setTagsContext({ app: "browser" });
        }

        if ( !this.get("group") ) {
            throw new Error("Missing group for BrowserApp");
        }
        console.log("[Browser] initialize()");

        // Collection of all retrieved results
        this.resultStore = new ResultStore();

        // Mapping of client_id => ResultView
        this.resultViews = {};

        // List of tag groups and their tags (sidebar data source)
        // [ { name: "", items: [ { id, tag, count }, ... ] }, .. ]
        this.tagGroups = [];

        // Mapping of { tag_id => [ clients ] }
        this.tagMapping = {};

        // Mapping of { class => [ tag_id, ...] }
        this.clientTagMapping = {};

        // Mapping of { tag_id => Results count }
        this.tagCounts = {};

        // TraminoClientsMap object, only initialized when the map tab was opened
        this.map = null;

        // How many items are rendered in a batch
        this.renderBatchSize = 8;

        _.bindAll(this,
            "processResults",
            "promiseError",
            "renderResults",
            "scrollHandler",
            "updateFavButton",
            "updateMapMarkers",
            "loadResults"
        );

        /* If it looks like a duck, assume it's one */
        var isSomethingMobile = navigator.userAgent.match(/iPad|iPhone|Android|Windows Phone/i) !== null;
        if ( isSomethingMobile ) {
            console.log("[BrowserApp] User-Agent looks like mobile");
            this.set("isTouchDevice", true);
        } else {
            /* Touch device detection */
            var handler = function() {
                console.log("[BrowserApp] Detected touch event, going into touch device mode");
                this.set("isTouchDevice", true);
                $(document).off('touchstart', handler);
            };
            $(document).on('touchstart', handler);
        }

        /* Dem Template-Loader einen Hinweis geben, dass wir der Browser sind */        
        require('../templates/main').setPrefix('browser/');

        console.log("[Browser] initialize() done");
    },

    run: function() {
        /* Validierung */
        if ( typeof window.TraminoFavoriten === "undefined" ) {
            throw new Error("Reserva: window.TraminoFavoriten ist nicht definiert.");
        }

        /* Bei Änderung der Tags oder Suche die Ergebnisse filtern und neu rendern */
        this.on('change:selectedTags', function(e) {
            this.filterResults();
            this.renderResults();
            this.updateMapMarkers();
            this.scrollUp();
        });

        /* Suche */
        this.on('change:searchQuery', function(e) {
            // Stichwortsuche
            var query = this.get("searchQuery").toLowerCase();
            if ( query.length > 2 ) {
                this.renderResultsSearch(query);
            } else {
                this.$search_list.html("");
                this.renderResults();
            }
        }.bind(this));

        /* Namens-Filter */
        var searchQueryInput = $('input[name="searchQuery"]');
        searchQueryInput.on('keyup', _.debounce(function() {
            this.set("searchQuery", searchQueryInput.val());
        }.bind(this), 300));

        /* Views vorbereiten */
        this.sidebarView = new SidebarView({
            el: document.getElementById('browser-sidebar'),
            model: this,
        });
        this.sortOrderView = new SortOrderView({
            el: document.getElementById('sort_order'),
            model: this,
        });
        this.$list = $('#results-list');
        this.$search_list = $('#results-search-list');
        if ( !this.$list.length ) {
            throw new Error("Result container not found: #results-list");
        }

        /* Rest der UI rendern */
        this.sortOrderView.render();

        /* Button für die Favoriten */
        TraminoFavoriten.on('change:items', this.updateFavButton);
        this.updateFavButton();

        /* Sobald alles bereit ist die Clients laden */
        this.loadTags().then(this.loadResults).catch(this.promiseError);

        /* Scroll-Handler fürs Nach-Rendern von Ergebnissen */
        $(window).on('scroll', _.throttle(this.scrollHandler, 200));

        /* Tabs für Liste und Karte initialisieren */
        var buttons = $('.result-tabs-buttons span');
        var tabs = $('.result-tabs .tab');
        var self = this;
        buttons.on('click', function(e) {
            var $this = $(this);
            var tab = $this.data('href');
            var $target = $('#tab-' + tab);
            self.set("tab", tab);

            console.log("Switch to", tab);

            buttons.removeClass('active');
            tabs.removeClass('active');
            $target.addClass('active');
            $this.addClass('active');

            // Wir sparen Zeit, wenn wir Google Maps nur einmal initialisieren und dann wiederverwerten
            if ( tab === "geo" && !self.map ) {

                // Karte erzeugen, aber noch keine Marker definieren. Diese laden wir danach erst per AJAX.
                self.map = new TraminoClientsMap({
                    target: 'partner-map',
                    data: [], // Filled out later
                    onClick: function(e, marker, betrieb) {
                        var view = self.resultViews[betrieb.id].clone();
                        view.render();
                        self.map.displayInfo(marker, view.el);
                    },
                });
                self.map.init().then(function() {
                    self.updateMapMarkers();    
                });
            }

            /* Sortierung bei der Karte ausblenden */
            if ( tab === "geo" ) {
                $('.tabs .right').hide();
            } else {
                $('.tabs .right').show();  
            }

        });

        /* Drucken Button */
        $('.print-group').on('click', function() {
            var resultIDs = this.resultStore.getVisible().map(result => result.id);
            location.search = "?mode=print&results=" + resultIDs.join(",");
        }.bind(this))

        /* Favoriten Filter */
        var fav_btns = $('.fav-group span');
        fav_btns.on('click', function(e) {
            var current = $(this);
            var href = current.data().href;

            fav_btns.removeClass("active");
            current.addClass("active");

            if ( href === "all" ) {
                self.set("favoritesOnly", false);
            }
            if ( href === "favs" ) {
                self.set("favoritesOnly", true);
            }

            self.filterResults();
            self.renderResults();
            self.updateMapMarkers();
        });
    },

    /**
     * Favoriten-Button aktualisieren
     */
    updateFavButton: function(e) {
        var count = 0;
        var favs = TraminoFavoriten.getItemsMap();
        this.resultStore.each(function(result) { // n = 0 - 100
            if ( !result.visible ) return;
            if ( typeof favs["clients-" + result.get("id")] !== "undefined" ) {
                count++;
            }
        });
        $('.fav-group span[data-href="favs"]').text(count === 0 ? "FAVORITEN" : (count === 1 ? "1 FAVORIT" : count + " FAVORITEN"));
    },

    /**
     * Marker auf der Karte aktualisieren
     */
    updateMapMarkers: function() {
        if ( !this.map ) return;
        this.map.clearMarkers();
        var clients = this.resultStore.getVisible().map(function(result) {
            return {
                id: result.id,
                name: result.get("geo_name"),
                lat: result.get("lat"),
                lng: result.get("lng"),
            };
        });
        this.map.addMarkers(clients);

        /* Karte neu ausrichten */
        var bounds = new google.maps.LatLngBounds();
        _.each(clients, function(b) {
            if ( b.lat && b.lng ) {
                bounds.extend(new google.maps.LatLng(b.lat, b.lng));
            }
        });

        /* Verhindern dass wir zu nah zoomen */
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
           var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
           var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
           bounds.extend(extendPoint1);
           bounds.extend(extendPoint2);
        }

        this.map.map.setCenter(bounds.getCenter());
        this.map.map.fitBounds(bounds); 
    },

    /**
     * Nicht anderweitig abgefangene Promise-Fehler behandeln
     */
    promiseError: function(e) {
        if ( typeof window.Raven !== "undefined" ) {
            Raven.captureException(e);
        }

        console.log(e);
    },

    /**
     * Sammelt alle URL-Parameter und gibt diese als Objekt zurück.
     */
    getQueryParameters: function() {
        var url = decodeURIComponent(window.location.search.substring(1));
        var variables = url.split('&');
        var parameters = {};

        for (var i = 0, part; part = variables[i]; i++) {
            var keyvalue = part.split('=');
            parameters[keyvalue[0]] = keyvalue[1];
        }
        return parameters;
    },

    //
    // Model methods
    //

    loadTags: function () {
        var timer = MiniTimer("Load Tags");

        var handler = function(response) {
            timer(); timer = MiniTimer("Parse Tags");

            this.tagGroups = [];
            this.tagMapping = {};
            this.clientTagMapping = {};

            var currentGroupName = null;
            var currentGroupId = null;
            var currentTags = [];

            for (var i = 0, result; result = response.tags_info[i]; ++i) {
                // result = { order, group, id, tag, [clients] }
                if ( !currentGroupName ) currentGroupName = result.group;
                if ( !currentGroupId ) currentGroupId = result.group_id;
                if ( currentGroupName != result.group ) {
                    this.tagGroups.push({
                        id: currentGroupId,
                        name: currentGroupName,
                        tags: currentTags,
                    });
                    currentGroupName = result.group;
                    currentGroupId = result.group_id;
                    currentTags = [];
                }

                currentTags.push({
                    id: result.id,
                    tag: result.tag,
                    count: null, /* null = Unknown count */
                });

                var clients = result.clients.split(',');

                /* Wir erzeugen hier ein Mapping von tag_id => Array von Clients.
                   Dies ermöglicht es uns später, schnell anhand der ausgewählten Tags die Ergebnisse zu filtern */
                for(var j = 0, client_id; client_id = clients[j]; ++j) {
                    if ( typeof this.tagMapping[result.id] === "undefined" ) {
                        this.tagMapping[result.id] = [];
                    }
                    this.tagMapping[result.id].push(parseInt(client_id, 10)); // result.id = tag.id

                    if ( typeof this.clientTagMapping[client_id] === "undefined" ) {
                        this.clientTagMapping[client_id] = [];
                    }
                    this.clientTagMapping[client_id].push(parseInt(result.id, 10)); // result.id = tag.id

                    this.tagCounts[client_id] = 0;
                }
            }

            this.tagGroups.push({
                id: currentGroupId,
                name: currentGroupName,
                tags: currentTags,
            });
            this.resetTagCounts();

            /* Gruppen filtern, die wir nicht brauchen */
            var tagGroupFilter = this.get("tagGroupFilter");
            if ( tagGroupFilter.length > 0 ) {
                this.tagGroups = this.tagGroups.filter(function(group) {
                    return tagGroupFilter.indexOf(group.id) !== -1;
                });
            }

            this.trigger("change:tags");

            timer();

        }.bind(this);

        var lang = window.Tramino.lang;
        var cache_key = "browser.tags." + lang;
        var cache = SafeStorage.session.get(cache_key);

        if ( cache ) {
            console.log("[Browser] Loading filter tags from Storage.session cache");
            return Promise.resolve(JSON.parse(cache)).then(handler).catch(this.promiseError);
        } else {
            console.log("[Browser] Loading filter tags from API");
            return ajax('/api/partner/tags/', {params: {lang: lang}}).then(function(result) {
                SafeStorage.session.set(cache_key, JSON.stringify(result), 3600 * 1000);
                return result;
            }).then(handler).catch(this.promiseError);
        }
    },

    resetTagCounts: function() {
        this.tagCounts = {};
        var tagCounts = this.tagCounts;
        _.each(this.tagGroups, function(group) { // n = ~4
            _.each(group.tags, function(tag) { // n = ~8
                tagCounts[tag.id] = [];
            });
        });
    },

    loadResults: function() {
        var timer = MiniTimer("Load results");
        this.$list.html(TemplateCache.render("LoadingIndicator"));

        ajax('/api/partner/?group=' + this.get('group')).then(function(result) {
            timer();

            // Ergebnisse hinzufügen und rendern
            this.processResults(result.results);

            /* Falls wir Tags aus der URL erhalten haben, diese anwenden */
            var requestedTags = this.getQueryParameters().tags;
            if ( requestedTags ) {
                this.set("selectedTags", _.map(requestedTags.split(','), function(x) { return parseInt(x, 10); }));
            }

            this.filterResults();
            this.renderResults();

        }.bind(this)).catch(function(e) {
            // e = jqXHR object
            this.$list.html(TemplateCache.render("ResultError", {
                error: e.statusText || e.message || e.toString(),
            }));
            this.promiseError(e);
        }.bind(this));
    },

    /**
     * Einkommende Ergebnisse verarbeiten:
     * - In den resultStore packen
     * - Views erzeugen
     * - Tags filtern (visible status)
     * - Anzeigen
     */
    processResults: function(results) {
        var timer = MiniTimer("processResults");
        for (var i = 0, result; result = results[i]; ++i) { // n = 1-20
            // Sortierparameter auftrennen
            var sort = result.sort ? result.sort : [0,0,0];
            result.sort_auto    = parseFloat(sort[0]);
            result.sort_name    = parseFloat(sort[1]);
            result.sort_ratings = parseFloat(sort[2]);

            var model = new Result(result);
            // Standard-Sichtbarkeit setzen
            model.visible = true;

            var view = new ResultView({
                model: model,
            });

            this.resultStore.add(model);
            this.resultViews[result.id] = view;
        }

        timer("added " + results.length + " results");
    },

    filterResults: function() {
        var selectedTags = this.get("selectedTags");
        var clientTagMapping = this.clientTagMapping;
        var tagMapping = this.tagMapping;
        var timer = MiniTimer("filterResults");
        var count = 0;

        if ( selectedTags.length > 0 ) {
            // Sichtbarkeit berechnen
            this.resultStore.each(function(result) { // n = 0 - 100
                // result = Backbone.Model
                var resultId = parseInt(result.id, 10);
                
                result.visible = true;
                for (var i = 0, tag_id; tag_id = selectedTags[i]; ++i) { // n = 0 - 4
                    var clients_with_this_tag = tagMapping[tag_id];
                    if ( typeof clients_with_this_tag === "undefined" ) {
                        throw new Error("tagMapping is missing tag #" + tag_id);
                    }
                    if ( clients_with_this_tag.length === 0 ) {
                        throw new Error("clients_with_this_tag is 0, which shouldn't happen #" + tag_id);
                    }
                    if ( clients_with_this_tag.indexOf(resultId) === -1 ) {
                        result.visible = false;
                    }
                }

                if ( result.visible ) count++;
            }.bind(this)); // Ende Berechnung Sichtbarkeit

            if ( count === 0 ) {
                Raven.captureMessage("TagfilterNoResults", {
                    extra: { selectedTags: selectedTags, }
                });
            }
        } else {

            // Es werden alle Ergebnisse angezeigt
            this.resultStore.each(function(result) { // n = 0 - 100
                result.visible = true;
            });

        }

        /* @todo Sollen wir bei einer Suchanfrage die Tags vergessen?
                 "Es wurden keine Partner mit diesem Namen in dieser Kategorie gefunden.
                  Sie könnten [alle Filter deaktiveren](resetFilter)."
        */
        var query = this.get("searchQuery");
        if ( query.length > 2 ) {
            query = query.toLowerCase();

            this.resultStore.each(function(result) { // n = 0 - 100
                var name = result.get("name").toLowerCase();
                result.visible = name.indexOf(query) !== -1;
            });
        }

        // Filterung nach Favoriten
        if ( this.get("favoritesOnly") ) {
            console.log("Filtering by favorites");
            var favs = TraminoFavoriten.getItemsMap();
            this.resultStore.each(function(result) { // n = 0 - 100
                if ( typeof favs["clients-" + result.get("id")] === "undefined" ) {
                    result.visible = false;
                }
            });
        }
        this.updateFavButton();

        // Tags zählen
        this.resetTagCounts();

        // Berechnen, welcher Tag wie viele sichtbaren Ergebnisse hat
        var tagCounts = this.tagCounts;
        this.resultStore.each(function(result) { // n = 0 - 100
            if ( !result.visible ) return;

            var tags_with_this_clients = clientTagMapping[result.id];

            _.each(tags_with_this_clients, function(tag_id) {
                // Nur Tags zählen, die wir auch in der Sidebar anzeigen
                if ( tagCounts.hasOwnProperty(tag_id) ) {
                    tagCounts[tag_id].push(result.id);
                }
            });
        });

        // Der Menüliste die Zähler zuweisen
        _.each(this.tagGroups, function(group) { // n = ~4
            _.each(group.tags, function(tag) { // n = ~8
                if ( tagCounts[tag.id] ) {
                    tag.count = _.unique(tagCounts[tag.id]).length;
                } else {
                    tag.count = 0;
                }
            });
            group.tags = _(group.tags).sortBy(function(tag) { return -tag.count; });
        });

        // Dem View mitteilen, dass die Seite neu gerendet werden kann
        this.trigger("change:tags");
        timer(count + " results are visible");
    },

    renderResults: function() {
        var timer = MiniTimer("renderResults");

        /* For performance reasons, we keep all result nodes around
           and just detach and re-attach them to the DOM when necesssary */
        _.each(this.resultViews, function(view, result_id) {
            view.hide();
        });
        this.lastRenderIndex = 0;
        this.renderMoreResults();
        timer();
    },

    /**
     * Zusätzliche Ergebnisse rendern
     */
    renderMoreResults: function() {
        var models = this.resultStore.getVisible();
        models = models.slice(this.lastRenderIndex, this.lastRenderIndex + this.renderBatchSize);

        if ( models.length === 0 && this.lastRenderIndex === 0 ) {
            if ( this.get("favoritesOnly") ) {
                this.$list.html("<div class='results-404'>Sie haben keine Favoriten, die den aktuellen Suchbedingungen entsprechen.</div>");
            } else {
                this.$list.html("<div class='results-404'>Keine Ergebnisse gefunden. Bitte versuchen Sie es mit einer anderen Abfrage.</div>");
            }
        }

        if ( models.length > 0 ) {

            console.log("[renderMoreResults] Found " + models.length + " results to render");

            // Sicherstellen, dass die Box leer ist falls keine Ergebnisse gerendert wurden
            if ( this.$list.find('.result-box').length === 0 ) this.$list.html("");

            var views = this.resultViews;
            _.each(models, function(result, i) {
                if ( !result.visible ) return;
                var view = views[result.id];
                if ( typeof view === "undefined" ) {
                    throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
                }

                if ( !view.rendered ) {
                    // Wir erzeugen erst die Elemente, wenn wir sie wirklich brauchen.
                    // Spart RAM und verhindert, dass Bilder zu früh geladen werden.
                    view.render();
                }

                view.show(this.$list);
                this.lastRenderIndex++;

            }.bind(this));

        }
    },

    /**
     * Rendering von Suchergebnissen
     */
    renderResultsSearch: function(query) {
        var timer = MiniTimer("renderResultsSearch");

        var models = this.resultStore.filter(function(result) {
            var name = result.get("name").toLowerCase();
            return name.indexOf(query) !== -1;
        });

        this.$search_list.html("");
        this.$search_list.append("<div class='results-divider'>Suchergebnisse</div>");

        if ( models.length === 0 ) {
            this.$search_list.append("<div class='results-404'>Keine Anbieter mit diesem Namen gefunden.</div>");
        } else {
            console.log("[renderResultsSearch] Found " + models.length + " results to render");

            var views = this.resultViews;
            _.each(models, function(result, i) {
                var view = views[result.id];
                if ( typeof view === "undefined" ) {
                    throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
                }

                if ( !view.rendered ) {
                    // Wir erzeugen erst die Elemente, wenn wir sie wirklich brauchen.
                    // Spart RAM und verhindert, dass Bilder zu früh geladen werden.
                    view.render();
                }
                view.hide();
                view.show(this.$search_list);
            }.bind(this));
        }

        this.$search_list.append("<div class='clear'></div>");
        this.$search_list.append("<div class='results-divider'>Weitere Anbieter</div>");


        timer();
    },

    //
    // User actions
    //

    setSortOrder: function(order) {
        var timer = MiniTimer("SortResults: " + order);
        var previous = this.get("sortBy");
        if ( order == previous ) return;
        var sortArrayIndex = {
            'auto': 0,
            'name': 1,
            'ratings': 2
        }[order];

        this.set("sortBy", order);
        this.resultStore.comparator = function(result) {
            return result.attributes.sort[sortArrayIndex];
        };
        this.resultStore.sort();

        timer();
        this.renderResults();
    },

    toggleTag: function(tag_id) {
        var tags = this.get("selectedTags");
        tag_id = parseInt(tag_id, 10);
        if ( _.contains(tags, tag_id) ) {
            tags.splice(tags.indexOf(tag_id), 1);
        } else {
            tags.push(tag_id);
        }

        this.set("selectedTags", tags);
        // Backbone wont trigger on set cause the array is still the same array object
        this.trigger("change:selectedTags");
    },

    //
    // View Methods
    //

    scrollHandler: function() {
        var scrollTop = $(window).scrollTop();
        var boxes = this.$list.find('.result-box');
        if ( !boxes.length ) {
            // Nothing has been rendered yet
            return;
        }
        if ( this.get("tab") !== "list" ) return;

        var lastBoxOffset = boxes.last().offset().top;
        var viewportBottom = scrollTop + $(window).height() + 100;
        if ( viewportBottom > lastBoxOffset ) {
            // Mehr Ergebnisse rendern
            this.renderMoreResults();
        }

    },

    scrollUp: function() {
        var currentScrollTop = $('html').scrollTop();
        if ( currentScrollTop === 0 ) return; /* Nicht scrollen wenn ganz oben */

        $('html, body').animate({
            scrollTop: $('.tabs').offset().top - 20,
        }, 400);
    },

});


module.exports = BrowserApp;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/browser/main.js